import { cssClasses } from './variables.js';

//=====================================================================
// Overlay events
//=====================================================================
export function modalAndOverlayStyleHandler(body, button, modalElements = {}, closeButton, animationSpeed, addStyle = true) {
    const itemsArray = Object.values(modalElements);
    let isHidden = addStyle ? "true" : "false";
    let toggleClass = addStyle ? "add" : "remove";

    body.classList[toggleClass](cssClasses.modelIsVisible);
    button.classList[toggleClass](cssClasses.isActive);
    button.setAttribute('aria-expanded', isHidden);
    isHidden = addStyle ? "false" : "true";
    modalElements.modal.setAttribute('aria-hidden', isHidden);
    modalElements.overlay.setAttribute('aria-hidden', isHidden);

    itemsArray.forEach((item) => {
        if (addStyle) {
            if (item === undefined) return;
            item.classList.add(cssClasses.isActive, cssClasses.isAnimatingIn);
            setTimeout(() => {
                item.classList.remove(cssClasses.isAnimatingIn);
            }, animationSpeed)
        } else {
            if (item === undefined) return;
            item.classList.add(cssClasses.isAnimatingOut);
            setTimeout(() => {
                item.classList.remove(cssClasses.isActive, cssClasses.isAnimatingOut);
            }, animationSpeed)
        }
    })
}